import { render } from "./AiRelayHistory.vue?vue&type=template&id=2d04dd79"
import script from "./AiRelayHistory.vue?vue&type=script&lang=js"
export * from "./AiRelayHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__